import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { ReactComponent as ModalClose } from "../../images/modal_close.svg";
import { ReactComponent as ValidIcon } from "../../images/check_marker_green.svg";
import { ReactComponent as InvalidIcon } from "../../images/cross_cricle_red.svg";
import styles from "./TestApiModal.module.css";
import { AuthenticationApiCalls } from "../../apis/AuthenticationApiCalls";
import { useLocalStorageNew } from "../../hooks/useLocalStorageNew";
import {
    BUTTON,
    CLOSE_MODAL,
    MODAL,
    MODAL_CANCEL_TEXT,
    TEST_API_MODAL_TITLE,
    TEST_API_MODAL_DESCRIPTION,
    TEST_API_COURSE_ID_LABEL,
    TEST_API_COURSE_ID_PLACEHOLDER,
    TEST_API_BUTTON_TEXT,
    TEST_API_COURSE_INFO_TITLE,
    TEST_API_COURSE_INFO_DESCRIPTION,
    TEST_API_COURSE_ROSTER_TITLE,
    TEST_API_COURSE_ROSTER_DESCRIPTION,
} from "../../utils/constants";
import YuJaButton from "../standardization/YuJaButton";
import { YuJaTextBox } from "../standardization/YuJaTextBox";
import { Spin } from "../../components/standardization/YuJaLoading";

export default function TestApiModal({show, onClose, intType}) {
    const [, getSession] = useLocalStorageNew("session", {});
    const {testLmsApiAccess} = AuthenticationApiCalls();

    const [courseId, setCourseId] = useState("");
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);

    useEffect(() => {
        if (show) {
            setCourseId(getSession().tpCourseId || "");
            setResult(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show]);

    const handleTestApi = () => {
        if (!courseId.trim() || loading) {
            return;
        }
        setLoading(true);
        setResult(null);
        testLmsApiAccess(intType, courseId.trim()).then(res => {
            setResult(res);
            setLoading(false);
        });
    };

    return (
        <Modal
            id="test-api-modal"
            show={show}
            onHide={onClose}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={true}
            dialogClassName={styles.dialog}
        >
            <ModalClose tabIndex={0} aria-label={CLOSE_MODAL} role={BUTTON} onClick={onClose} className="modal-close" />
            <Modal.Header style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                <Modal.Title aria-label={TEST_API_MODAL_TITLE + MODAL} className={styles.title} id="contained-modal-title-vcenter">
                    {TEST_API_MODAL_TITLE}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className={styles.container}>
                    <div className={styles.description}>
                        {TEST_API_MODAL_DESCRIPTION}
                    </div>

                    {loading 
                        ?
                        <div className={styles.spinnerRow}>
                            <Spin spinning={true} size="large" overlay={false} />
                        </div>
                        :
                        (
                            result 
                            ?
                            <div className={styles.container}>
                                <div className={styles.resultRow}>
                                    {result.courseCheck?.passed ? <ValidIcon /> : <InvalidIcon />}
                                    <div>
                                        <div className={styles.resultRowTitle}>{TEST_API_COURSE_INFO_TITLE}</div>
                                        <div className={styles.resultRowDescription}>{TEST_API_COURSE_INFO_DESCRIPTION}</div>
                                    </div>
                                </div>
                                <div className={styles.resultRow}>
                                    {result.rosterCheck?.passed ? <ValidIcon /> : <InvalidIcon />}
                                    <div>
                                        <div className={styles.resultRowTitle}>{TEST_API_COURSE_ROSTER_TITLE}</div>
                                        <div className={styles.resultRowDescription}>{TEST_API_COURSE_ROSTER_DESCRIPTION}</div>
                                    </div>
                                </div>
                            </div>
                            :
                            <div className={styles.fieldGroup}>
                                <div className={styles.fieldLabel}>{TEST_API_COURSE_ID_LABEL}</div>
                                <div className={styles.testRow}>
                                    <YuJaTextBox
                                        placeholder={TEST_API_COURSE_ID_PLACEHOLDER}
                                        name="courseId"
                                        label={TEST_API_COURSE_ID_LABEL}
                                        value={courseId}
                                        onChange={(e) => setCourseId(e.target.value)}
                                        containerStyle={{marginBottom: 0, flex: 1}}
                                    />
                                    <YuJaButton onClick={handleTestApi} disabled={!courseId.trim() || loading} size="large">
                                        {TEST_API_BUTTON_TEXT}
                                    </YuJaButton>
                                </div>
                            </div>
                        )

                    }
                </div>
            </Modal.Body>
            <Modal.Footer>
                <YuJaButton type="secondary" onClick={onClose}>
                    {MODAL_CANCEL_TEXT}
                </YuJaButton>
            </Modal.Footer>
        </Modal>
    );
}
